export default __webpack_public_path__ + "static/media/Bukidnon3.63574a3e.png";